import React from 'react';
import Header from './components/header';
import { HashRouter, Link, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Impressum from './components/Impressum';
import Home from './components/Home';
import TankReinigung from './pages/Tankreinigung';
import Strassenlaternenmastlackierung from './pages/Strassenlaternenmastlackierung';
import LeichterKorrosionsschutz from './pages/LeichterKorrosionsschutz';

function App() {
  return (
    <Router>
      <div className='app'>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/tankreinigung" element={<TankReinigung />} />
          <Route path="/strassenlaternenmastlackierung" element={<Strassenlaternenmastlackierung />} />
          <Route path="/leichterKorrosionsschutz" element={<LeichterKorrosionsschutz />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;


//Abdjassem5000@gmail.com
//passwort: SF2dsnve32@